/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Rcnv_Quote_BeforeInputs */

const es_landing_rcnv_quote_before = /** @type {(inputs: Landing_Rcnv_Quote_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarpar nos da mucha flexibilidad al permitirnos usar barcos y neumáticas `)
};

const gl_landing_rcnv_quote_before = /** @type {(inputs: Landing_Rcnv_Quote_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarpar dános moita flexibilidade ao permitirnos usar barcos e neumáticas `)
};

const en_landing_rcnv_quote_before = /** @type {(inputs: Landing_Rcnv_Quote_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarpar gives us great flexibility by letting us use boats and RIBs `)
};

/**
* | output |
* | --- |
* | "Zarpar gives us great flexibility by letting us use boats and RIBs" |
*
* @param {Landing_Rcnv_Quote_BeforeInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_rcnv_quote_before = /** @type {((inputs?: Landing_Rcnv_Quote_BeforeInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Rcnv_Quote_BeforeInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_rcnv_quote_before(inputs)
	if (locale === "en") return en_landing_rcnv_quote_before(inputs)
	return es_landing_rcnv_quote_before(inputs)
});